import React from 'react';

import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ActionItemKeys, getProviderStripeConnectProfileLink } from '@uplift/api';
import { trackToDoCTA } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { AsyncButton, StackableCard } from '@uplift/ui-v2';

import skySrc from '../../../../../assets/images/sky.jpg';
import { LaunchRounded } from '@mui/icons-material';
import { useCurrentuser } from '@uplift/contexts';
import { asyncWait } from '@uplift/utils';

const useSeePsychStyles = makeStyles()(theme => ({
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(1),
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    }
  },
  background: {
    background: `url(${skySrc}) lightgray 50% / cover no-repeat`,
  },
  content: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3)
  },
  body: {
    paddingTop: theme.spacing(0.5),
  }
}));

export const SetupPayoutAccount = () => {
  const me = useCurrentuser();
  const { classes } = useSeePsychStyles();

  const onClick = async () => {
    trackToDoCTA({
      toDoType: ActionItemKeys.PROVIDER_SETUP_PAYOUT_ACCOUNT,
      userType: UserRole.provider
    });

    const profileLink = await getProviderStripeConnectProfileLink(me.id);

    window.open(profileLink.data, '_self');
    await asyncWait(10000);
  };

  return (
    <StackableCard className={classes.background}>
      <Box className={classes.content}>
        <Box fontWeight={600}>
          Action Required — Set up a Payouts Account
        </Box>
        <Typography variant="body2" color="textPrimary" className={classes.body}>
          We are updating our payouts method to use Stripe. You’ll need to connect your account to keep getting paid — it’s quick and secure. Need help? Check out the Payment FAQ’s.
        </Typography>
        <Box className={classes.actions}>
          <AsyncButton
            variant="contained"
            color="secondary"
            fullWidth
            onClick={onClick}
            endIcon={<LaunchRounded />}
            loadingPosition="end"
          >
            Set up account
          </AsyncButton>
        </Box>
      </Box>
    </StackableCard>
  );
};
